import styled from 'styled-components'
import { colorTheme } from '../../../../style/theme/colorTheme'

export const BellAnimationWrap = styled.div`
	position: relative;
	width: 2.5em;
	height: 1.72em;

	> svg {
		fill: ${colorTheme.restaurant.waiterCall.background};
	}

	.bell {
		animation: moveUpDown 0.9s infinite ease-in-out;
		animation-fill-mode: forwards;
	}

	.dots {
		opacity: 0;
		animation: showDots 0.9s infinite ease-in-out;
		animation-fill-mode: forwards;
	}

	@keyframes showDots {
		0%, 60% {
			opacity: 0;
		}
		20%, 80% {
			opacity: 1;
		}
		40%, 100% {
			opacity: 0;
		}
	}

	@keyframes moveUpDown {
		0% {
			transform: translateY(0);
		}
		20% {
			transform: translateY(2px)
		}
		40% {
			transform: translateY(0);
		}
		60% {
			transform: translateY(0);
		}
		80% {
			transform: translateY(2px)
		}
		100% {
			transform: translateY(0);
		}
	}

`
BellAnimationWrap.displayName = 'BellAnimationWrap'
